module.exports = __webpack_public_path__ + "d6b07cccee273e44ebba17aba8bc8300.png";